<template>
  <v-dialog max-width="600" v-model="visible">
    <v-btn flat color="green" slot="activator" class="mb-2">
      <span>Add Position</span>
      <v-icon right>add</v-icon>
    </v-btn>

    <v-card>
      <v-card-title>
        <h2>Add new Crew Position</h2>
      </v-card-title>

      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field label="Title" v-model="title" :rules="[rules.required]" outline />
          <v-text-field label="Payment" v-model="payment" :rules="[rules.required, rules.number]" prefix="$" outline />
          <v-checkbox label="Required on Event Assignments" v-model="required" />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <span id="error" class="error--text pl-4 title">{{ error }}</span>
        <v-spacer />
        <v-btn color="blue" class="mr-4 mb-2" @click="createPosition()">
          <span>Create</span>
          <v-icon right>add</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {Positions} from '../fbConfig';

export default {
  name: 'AddPositionDialog',
  data() {
    return {
      visible: false,
      title: '',
      payment: 0,
      required: true,
      rules: {
        required: value => !!value || 'This field is required',
        number: value => (!Number.isNaN(Number(value)) && Number(value) >= 0) || 'Please enter a positive number'
      },
      error: ''
    };
  },
  methods: {
    createPosition() {
      if (this.$refs.form.validate() === false) {
        return;
      }

      const title = this.title.trim();
      for (const position of this.$store.state.positions) {
        if (position.title.toLowerCase() === title.toLowerCase()) {
          this.error = 'A position with that title already exists!';

          setTimeout(() => { this.error = ''; }, 5000);
          return;
        }
      }

      const position = {
        title,
        payment: this.payment,
        required: this.required
      };

      Positions.add(position).then(() => {
        this.$refs.form.reset();
      });
    }
  },
  created() {
    Positions.onSnapshot(res => {
      for (const change of res.docChanges()) {
        if (change.type === 'added') {
          this.$store.commit('addPosition', {
            id: change.doc.id,
            ...change.doc.data()
          });
        }
      }
    });
  }
};
</script>

<style scoped>

</style>
